// Deliberately not a "use client" module: the server layout imports this, and a
// non-component export pulled from a client module arrives as a reference stub,
// not the string — so the cookie lookup silently never matched.
export const SIDEBAR_EXPANDED_COOKIE = "sidebar_expanded";

export const isSidebarExpandedIn = (cookieStore: {
  get: (name: string) => { value: string } | undefined;
}): boolean => cookieStore.get(SIDEBAR_EXPANDED_COOKIE)?.value !== "0";
